import { ReactNode } from 'react'

interface Props {
  children: ReactNode
  fullWidth?: boolean
  fullBleed?: boolean
}

export default function SectionContainer({
  children,
  fullWidth = false,
  fullBleed = false,
}: Props) {
  // If fullBleed is true, use special classes to break out of any parent constraints
  if (fullBleed) {
    return (
      <section className="relative right-[50%] left-[50%] -mr-[50vw] -ml-[50vw] w-screen">
        {children}
      </section>
    )
  }

  // Regular section with consistent padding and width constraints
  return (
    <section
      className={`mx-auto w-full ${fullWidth ? 'px-4 sm:px-6 md:px-8 lg:px-10' : 'max-w-7xl'}`}
    >
      {children}
    </section>
  )
}
